const imageAxios='https://apis.trulyyourswelfare.com'
//const imageAxios='http://localhost:7000'
export default imageAxios;